// Shared tab bar rendered at the top of every page under /admin/auspost/*.
// Uses NavLink so the active state flips correctly on direct deep-links and
// browser back/forward.

import { NavLink } from 'react-router-dom'
import { Layers, FileText } from 'lucide-react'

const TABS = [
  { to: '/admin/auspost',          label: 'Reconciliation', icon: Layers,   end: true },
  { to: '/admin/auspost/invoices', label: 'Invoice uploads', icon: FileText, end: false },
]

export default function AuspostTabs() {
  return (
    <div className="border-b border-slate-200 -mt-2 flex flex-wrap items-center gap-1">
      {TABS.map(({ to, label, icon: Icon, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          className={({ isActive }) =>
            [
              'inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap',
              isActive
                ? 'border-blue-600 text-blue-700'
                : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300',
            ].join(' ')
          }
        >
          <Icon size={14} />
          {label}
        </NavLink>
      ))}
    </div>
  )
}
